// Libraries
import React from 'react';
import ReactGA from 'react-ga4';
import {
  // Box,
  Link,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';

const Footer = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isXsOrSm = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Stack
      direction='row'
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '1vh',
        color: 'text.primary',
        backgroundColor: 'background.paper',
        fontFamily: 'Arial',
      }}
    >
      <Typography
        variant="body1"
        sx={{
          display: { xs: 'none', sm: 'inherit' },
        }}
      >
        © 2025 Endoc
      </Typography>
      <Stack 
        direction={'row'} 
        spacing={3}
        sx={{
          alignItems:'center'
        }}>
        <Link
          style={{ textDecoration: 'none' }}
          onClick={() => {
            window.open(
              process.env.REACT_APP_TEAMS_URL,
              '_blank',
              'noreferrer'
            );
          }}
          sx={{
            fontWeight: 'bold',
            cursor: 'pointer',
          }}
        >
          Community
        </Link>
        <Link
          style={{ textDecoration: 'none' }}
          onClick={() => {
            ReactGA.event({
              category: 'Documentation',
              action: 'Go to documentation',
              label: 'User selected to go documentation',
            });

            window.open(
              process.env.REACT_APP_PLATFORM_DOCUMENTATION,
              '_blank',
              'noreferrer'
            );
          }}
          sx={{
            fontWeight: 'bold',
            cursor: 'pointer',
          }}
        >
          Documentation
        </Link>
        {process.env.REACT_APP_ETH === 'true' && (
          <Link 
            style={{ textDecoration: 'none' }}
            onClick={() => navigate('/contact')}>
            <Typography
              variant="span"
              sx={{
                fontWeight: 'bold',
                cursor: 'pointer',
              }}
            >
              Contact
            </Typography>
          </Link>
        )}
        <Link
          style={{ textDecoration: 'none' }}
          onClick={() => navigate('/privacy-policy')}
          sx={{
            fontWeight: 'bold',
            cursor: 'pointer',
          }}
        >
          {isXsOrSm ? 'Policy' : 'Privacy Policy'}
        </Link>
        <Link
          style={{ textDecoration: 'none' }}
          onClick={() => navigate('/terms-of-service')}
          sx={{
            fontWeight: 'bold',
            cursor: 'pointer',
          }}
        >
          {isXsOrSm ? 'ToS' : 'Terms of Service'}
        </Link>
      </Stack>
    </Stack>
  );
};

export default Footer;
